import { Injectable } from '@angular/core'
import { FeathersService } from './feathers.service'
import { DateRange } from './date-utils.service'
import { ExchangeEnrollment } from '../models/exchangeEnrollment'
import { AnnouncementRead } from '../models/announcementRead'

@Injectable({
  providedIn: 'root',
})
export class ExchangeService {
  private TAG = 'ExchangeService'

  constructor(private feathers: FeathersService) {}

  public getActiveEnrollmentsEmbracingRange(range: DateRange) {
    return this.feathers.find(ExchangeEnrollment, {
      queryType: 'activeEnrollmentsEmbracingRange',
      queryProps: {
        range,
      },
    })
  }

  public async deleteEnrollmentById(id: number) {
    await this.feathers.removeById(ExchangeEnrollment.serviceName, id)
  }
}
